<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="search">
        <el-form-item label="城市:">
          <el-select v-model="search.city" clearable placeholder="筛选城市">
            <el-option
                    v-for="item in cities" :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getEnergyPrices">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="energyPrices" border highlight-current-row v-loading="listLoading"
              style="width: 100%;">
      <el-table-column header-align="center" align="center" :formatter="formatCity" label="城市" min-width="120">
      </el-table-column>
      <el-table-column header-align="center" prop="level" label="用电时段" :formatter="formatLevel" align="center" min-width="100">
      </el-table-column>
      <el-table-column header-align="center" label="价格" align="center" width="130">
        <template scope="scope">
          {{scope.row.price}} 元/度
        </template>
      </el-table-column>
      <el-table-column header-align="center" label="创建时间" :formatter="formatCreatedTime" width="150" align="center">
      </el-table-column>
      <el-table-column header-align="center" align="center" label="更新时间" :formatter="formatUpdatedTime" width="150">
      </el-table-column>
      <el-table-column header-align="center" align="center" label="操作" width="150">
        <template scope="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total"
                     style="float:right;">
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog title="编辑费率" v-model="editFormVisible" size="tiny" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-form-item label="城市" prop="cityId">
          <el-select v-model="editForm.cityId" placeholder="请选择" :disabled="true">
            <el-option
                    v-for="item in cities" :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用电时段" prop="level">
          <el-select v-model="editForm.level" placeholder="请选择" :disabled="true">
            <el-option
                    v-for="item in levels" :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="价格" prop="price">
          <el-input  v-model="editForm.price" style="width:80px;margin-right: 10px;"></el-input>元/度
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增费率" v-model="addFormVisible" size="tiny" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-form-item label="城市" prop="cityId">
          <el-select v-model="addForm.cityId" placeholder="请选择">
            <el-option
                    v-for="item in cities" :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用电时段" prop="level">
          <el-select v-model="addForm.level" placeholder="请选择">
            <el-option
                    v-for="item in levels" :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="价格" prop="price">
          <el-input  v-model="addForm.price" style="width:80px;margin-right: 10px;"></el-input>元/度
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import util from '../../common/js/util'
  import moment from 'moment'
  import bcrypt from 'bcryptjs'
  //import NProgress from 'nprogress'
  import {getEnergyPriceList, addEnergyPrice, editEnergyPrice, removeEnergyPrice, getCityList} from '../../api/api';

  export default {
    data() {
      var validateWordAndNumberAndChinese = (rule, value, callback) => {
        var jgpattern =/^[\u4e00-\u9fa5_（）\(\)a-zA-Z0-9]+$/;
        if(!jgpattern.test(value)){
          callback(new Error('请输入中文、字母、数字、圆括号或下划线'));
        } else {
          callback();
        }
      };
      var validateWordAndNumberAndSpaceAndChinese = (rule, value, callback) => {
        var jgpattern =/^[\u4e00-\u9fa5 _（）\(\)a-zA-Z0-9]+$/;
        if(!jgpattern.test(value)){
          callback(new Error('请输入中文、字母、数字、圆括号、空格或下划线'));
        } else {
          callback();
        }
      };
      var validateChinese = (rule, value, callback) => {
        var jgpattern =/^[\u4e00-\u9fa5]+$/;
        if(!jgpattern.test(value)){
          callback(new Error('请输入中文'));
        } else {
          callback();
        }
      };
      var validateWordAndNumber = (rule, value, callback) => {
        var jgpattern =/^[A-Za-z0-9]+$/;
        if(!jgpattern.test(value)){
          callback(new Error('请输入字母或数字'));
        } else {
          callback();
        }
      };
      var validateNumber = (rule, value, callback) => {
        var jgpattern =/^[+0-9]+$/;
        if(!jgpattern.test(value)){
          callback(new Error('请输入数字'));
        } else {
          callback();
        }
      };
      var validateNumberAndDot = (rule, value, callback) => {
        var jgpattern =/^[.0-9]+$/;
        if(!jgpattern.test(value)){
          callback(new Error('请输入数字或小数点'));
        } else {
          callback();
        }
      };
      return {
        search: {
          city: ''
        },
        levels: [
          {
            name: '尖峰',
            id: 1
          },
          {
            name: '高峰',
            id: 2
          },
          {
            name: '平段',
            id: 3
          },
          {
            name: '低谷',
            id: 4
          }
        ],
        cities: [],
        energyPrices: [],
        total: 0,
        page: 1,
        listLoading: false,

        editFormVisible: false,//编辑界面是否显示
        editLoading: false,
        editFormRules: {
          price: [
            {required: true, message: '请输入价格'},
            {validator: validateNumberAndDot, trigger: 'blur'}
          ],
        },
        //编辑界面数据
        editForm: {
          id: '',
          cityId: '',
          level: 0,
          price: 0,
        },

        addFormVisible: false,//新增界面是否显示
        addLoading: false,
        addFormRules: {
          cityId: [
            {required: true, message: '请选择城市', trigger: 'change'},
          ],
          level: [
            {required: true, message: '请选择用电时段'},
          ],
          price: [
            {required: true, message: '请输入价格'},
            {validator: validateNumberAndDot, trigger: 'blur'}
          ],
        },
        //新增界面数据
        addForm: {
          cityId: '',
          level: null,
          price: null,
        },
      }
    },
    filters: {

    },
    methods: {
      cleanFilter() {
        this.search.city = '';
        this.getEnergyPrices();
      },
      formatCity: function (row) {
        var city = this.cities.find(t => {
          return t.id == row.cityId;
        });
        return city ? city.name : '';
      },
      formatLevel: function (row) {
        var level = this.levels.find(t => {
          return t.id == row.level;
        });
        return level ? level.name : '';
      },
      formatCreatedTime: function (row, column) {
        return moment(row.createdAt).format('YYYY-MM-DD');
      },
      formatUpdatedTime: function (row, column) {
        return moment(row.updatedAt).format('YYYY-MM-DD');
      },
      handleCurrentChange(val) {
        this.page = val;
        this.getEnergyPrices();
      },
      //获取企业列表
      getEnergyPrices() {
        let para = {
          page: this.page,
          size: 10,
          cityId: this.search.city,
        };
        this.listLoading = true;
        //NProgress.start();
        getEnergyPriceList(para).then((res) => {
          this.total = res.data.total;
          this.energyPrices = res.data.list;
          this.listLoading = false;
          //NProgress.done();
        });
      },
      //获取城市列表
      getCities() {
        let para = {
          size: 50
        };
        //NProgress.start();
        getCityList(para).then((res) => {
          this.cities = res.data.list;
          //NProgress.done();
        });
      },
      //删除
      handleDel: function (index, row) {
        this.$confirm('确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {
          this.listLoading = true;
          //NProgress.start();
          removeEnergyPrice(row.id).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getEnergyPrices();
          });
        }).catch(() => {

        });
      },
      //显示编辑界面
      handleEdit: function (index, row) {
        this.editFormVisible = true;
        this.editForm = Object.assign({}, row);
      },
      //显示新增界面
      handleAdd: function () {
        this.addFormVisible = true;
        if(this.$refs['addForm']) {
          this.$refs['addForm'].resetFields();
        }
        this.addForm = {
          cityId: '',
          level: null,
          price: null,
        };
      },
      //编辑
      editSubmit: function () {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.editLoading = true;
              //NProgress.start();
              let para = {
                id: this.editForm.id,
                cityId: this.editForm.cityId,
                level: this.editForm.level,
                price: this.editForm.price,
              };
              editEnergyPrice(para).then((res) => {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: '提交成功',
                  type: 'success'
                });
                this.$refs['editForm'].resetFields();
                this.editFormVisible = false;
                this.getEnergyPrices();
              });
            });
          }
        });
      },

      //新增
      addSubmit: function () {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.addLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.addForm);
              addEnergyPrice(para).then((res) => {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: '提交成功',
                  type: 'success'
                });
                this.$refs['addForm'].resetFields();
                this.addFormVisible = false;
                this.getEnergyPrices();
              });
            });
          }
        });
      },
    },
    mounted() {
      this.getEnergyPrices();
      this.getCities();
    }
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// EnergyPrice.vue?67c03590